import React, { useState } from "react";
import { FormGroup, FormGroupLabel, TextInput } from "gumdrops";

export default function CreateCampaignForm() {
  const [campaignName, setCampaignName] = useState("");
  const [jiraName, setJiraName] = useState("");
  const _handleInputChange = ({ target }) => setCampaignName(target.value);
  const _handleJiraChange = ({ target }) => setJiraName(target.value);
  return (
    <div>
      <FormGroup>
        <FormGroupLabel text="Name*" />
        <TextInput
          name="name"
          onChange={_handleInputChange}
          value={campaignName}
          placeholder="Campaign Name"
          size="sm"
          type="text"
        />
        <FormGroupLabel text="Jira Url (optional)" />
        <TextInput
          name="jira"
          onChange={_handleJiraChange}
          value={jiraName}
          placeholder="https://gumgum.jira.com/browse/DTR-5947"
          size="sm"
          type="url"
        />
      </FormGroup>
    </div>
  );
}
